import { useContext } from 'react';
import { TabViewSkeleton } from '@/components/TabView';
import { WorkspaceBrandContainer } from '@/containers/Workspace.Brand/Brand.Container';
import { BrandLoadingContext } from '@/containers/Workspace.Brand/Context';
import { BrandTabView } from './Brand.TabView';
import { Header } from './Header';
import styles from './style/Workspace.Brand.module.css';

const ViewComponent = () => {
  const isLoading = useContext(BrandLoadingContext);

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <Header />
        {isLoading
          ? <TabViewSkeleton />
          : <BrandTabView />}
      </div>
    </div>
  );
};

export const WorkspaceBrand = () => (
  <>
    <WorkspaceBrandContainer>
      <ViewComponent />
    </WorkspaceBrandContainer>
  </>
);

WorkspaceBrand.displayName = 'Workspace.Brand';